import React, { Component, Fragment } from 'react'
import {
    DKIcons, DKLabel, DKIcon, showToast, TOAST_TYPE, DKLine, INPUT_VIEW_DIRECTION
} from "deskera-ui-library";
import DKDateTime from './DKDateTime';
import Utility from '../../utility/Utility';

export default class DKInputDateTime extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: this.props.selectedDate ? this.props.selectedDate : new Date(),
            needDateTime: false,
            date: null,
            time: null,
        };
    }

    componentDidMount() {
        this.getDateTimeShow()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ selectedDate: nextProps.selectedDate }, () => this.getDateTimeShow())
    }

    render() {
        return (
            <Fragment>
                {this.props.direction === INPUT_VIEW_DIRECTION.HORIZONTAL &&
                    <div className={`row row-responsive justify-content-between align-items-start ${this.props.className || ""}`}>
                        {this.props.title && !this.props.hideLabel &&
                            <div className="mr-l">
                                <DKLabel text={this.props.title} className="row-auto-width mb-xs dkinput-header-section mt-r" />
                            </div>
                        }
                        <div className="column parent-width">
                            <div className="p-s border-m border-radius-s bg-gray1 row justify-content-between">
                                <div className={`row ${!this.props.readOnly ? "cursor-hand":""} parent-width`} onClick={() => this.showDateTimePopup()}>
                                    {!this.props.hideCalendar && <div className="position-relative row parent-width" >
                                        <DKIcon src={DKIcons.ic_calendar} className="ic-s mr-r" />
                                        <DKLabel text={`${this.state.date}, `} />
                                    </div>}
                                    <div className="position-relative row parent-width">
                                        <DKLabel text={this.state.time} />
                                        {this.props.hideCalendar && <DKIcon src={DKIcons.ic_recent} className="ic-s ml-auto" />}
                                    </div>
                                </div>
                            </div>
                            {this.props.invalid && this.props.errorMessage &&
                                <div style={{ marginTop: "2px", marginBottom: "-8px" }}>
                                    <DKLabel className="ml-xs fs-s text-red" text={this.props.errorMessage} />
                                </div>
                            }
                        </div>
                        {this.state.needDateTime && this.getDateTimePicker()}
                    </div>
                }
                {this.props.direction !== INPUT_VIEW_DIRECTION.HORIZONTAL &&
                    <div className={this.props.className ? this.props.className : ""}>
                        {(this.props.title && !this.props.hideLabel) && (<DKLabel text={this.props.title} className={`${this.props.labelClass}mt-l mb-s `} />)}
                        <div className="p-s border-m border-radius-s bg-gray1 row justify-content-between">
                            <div className={`row ${!this.props.readOnly ? "cursor-hand":""} parent-width`} onClick={() => this.showDateTimePopup()}>
                                {!this.props.hideCalendar && <div className="position-relative row parent-width" >
                                    <DKIcon src={DKIcons.ic_calendar} className="ic-s mr-r" />
                                    <DKLabel text={`${this.state.date}, `} />
                                </div>}
                                <div className="position-relative row parent-width">
                                    <DKLabel text={this.state.time} />
                                    {this.props.hideCalendar && <DKIcon src={DKIcons.ic_recent} className="ic-s ml-auto" />}
                                </div>
                            </div>
                        </div>
                        {this.state.needDateTime && this.getDateTimePicker()}
                    </div>
                }
            </Fragment>
        )
    }
    showDateTimePopup = () => {
        if(!this.props.readOnly) {
            this.setState({ needDateTime: true });
        }
    };

    hideDateTimePopup = () => {
        this.setState({ needDateTime: false });
    };

    getDateTimePicker = () => {
        return (
            <div className="transparent-background">
                <div className="popup-window justify-content-center justify-content-start-mobile">
                    <DKLabel text={this.props.title} className="fw-m fs-m mb-m" />
                    <DKLine className="mb-m" />
                    <DKDateTime
                        is12Hour={(this.props.is12Hour === null || this.props.is12Hour === undefined) ? true : this.props.is12Hour}
                        selectedDate={this.state.selectedDate}
                        hideCalendar={this.props.hideCalendar ? true : false}
                        hideFooterDateTime={this.props.hideFooterDateTime ? true : false}
                        onSave={(date) => {
                            this.publishDateUpdate(date)
                        }}
                        onClose={() => {
                            this.hideDateTimePopup()
                        }}
                        hasMaxHours={this.props.hasMaxHours}
                    />
                </div>
            </div>
        )
    }


    getDateTimeShow = () => {
        let date = (this.state.selectedDate && !this.props.hasMaxHours) ? new Date(this.state.selectedDate) : new Date()
        this.setState({ date: date.toDateString(), time: this.formatAMPM(date) })
    }

    formatAMPM = (date) => {
        if(this.props.hasMaxHours) {
            if(!Utility.isEmpty(this.state.selectedDate)) {
                const hhMM = this.state.selectedDate.split(":");
                hhMM[1] = hhMM[1].length==1 ? "0"+hhMM[1]:hhMM[1];
                hhMM[0] = hhMM[0].length==1 ? "0"+hhMM[0]:hhMM[0];
                return `${hhMM[0]}:${hhMM[1]}`
            }
            return this.state.selectedDate 
        }
        const is12Hour = (this.props.is12Hour === null || this.props.is12Hour === undefined) ? true : this.props.is12Hour;
        let strTime;
        let hours = date.getHours();
        let minutes = date.getMinutes();

        if (is12Hour) {
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours < 10 ? '0' + hours : hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes;
            strTime = `${hours}:${minutes} ${ampm}`;
        } else {
            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            strTime = `${hours}:${minutes}`;
        }

        return strTime;
    }

    publishDateUpdate = (date) => {
        var dateNew = Math.round((new Date(date)).getTime() / 1000);
        let todayDate = Math.round((new Date()).getTime() / 1000);
        if (todayDate > dateNew && !this.props.hideCalendar) {
            showToast('Please do not select past date', TOAST_TYPE.FAILURE);
            return
        }
        this.getDateTimeShow()
        this.hideDateTimePopup()
        this.props.onSave(date)
    }
}
